const actions = new Set(['opened','started','completed','product_clicked']);
export function metricPayload(detail, context = {}) {
  if (!actions.has(detail?.action)) return null;
  const clean = value => typeof value === 'string' ? value.slice(0,80) : '';
  return {
    name: context.preview ? 'bymjm_keuzehulp_test' : `bymjm_keuzehulp_${detail.action}`,
    data: { finder_action: detail.action, finder_entry: clean(detail.entry), finder_kind: clean(detail.kind), finder_mode: clean(detail.mode), finder_language: clean(detail.locale), finder_country: clean(detail.country), finder_distance: clean(detail.distance), finder_size: clean(detail.size), finder_color: clean(detail.color), finder_packs: clean(detail.packs), item_id: clean(detail.item_id), result_count: Number.isFinite(detail.result_count) ? Math.max(0,Math.round(detail.result_count)) : 0, finder_page: clean(context.path) }
  };
}
if (typeof document !== 'undefined') {
  const dialog = document.getElementById('bymjm-finder-dialog');
  let opener, mountPromise;
  const publish = detail => {
    const payload = metricPayload(detail, {preview: window.Shopify?.designMode === true || window.Shopify?.theme?.role !== 'main', path: location.pathname});
    if (!payload || typeof window.Shopify?.analytics?.publish !== 'function') return;
    try {
      const sent = window.Shopify.analytics.publish(payload.name,payload.data);
      if (sent && typeof sent.catch === 'function') sent.catch(()=>{});
    } catch {}
  };
  document.addEventListener('bymjm:finder-event',event=>publish(event.detail));
  const close = () => dialog?.close();
  if (dialog) {
    dialog.querySelector('[data-finder-close]').addEventListener('click',close);
    dialog.addEventListener('click',event=>{
      if (event.target !== dialog) return;
      const bounds=dialog.getBoundingClientRect();
      if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)close();
    });
    dialog.addEventListener('close',()=>{
      document.documentElement.classList.remove('bf-dialog-open');
      if(opener?.isConnected)opener.focus({preventScroll:true});
    });
  }
  document.addEventListener('click',async event=>{
    const link=event.target.closest('a[data-finder-open]');
    if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||!dialog||typeof dialog.showModal!=='function')return;
    event.preventDefault();
    opener=link;
    const entry=link.dataset.finderSource==='index'?'home':link.dataset.finderSource||'direct';
    const kind=link.dataset.finderKind||'';
    if(!dialog.open)dialog.showModal();
    document.documentElement.classList.add('bf-dialog-open');
    try {
      if(!mountPromise)mountPromise=import(dialog.dataset.finderModule).then(()=>{
        const fragment=dialog.querySelector('[data-finder-template]').content.cloneNode(true);
        dialog.querySelector('[data-finder-mount]').append(fragment);
        return dialog.querySelector('bymjm-finder');
      }).catch(error=>{mountPromise=null;throw error;});
      const finder=await mountPromise;
      finder.setContext(kind,entry);
      publish({action:'opened',entry,kind:kind||finder.state.kind||'unknown',mode:'panel',locale:finder.config.locale,country:finder.config.country});
      dialog.querySelector('[data-finder-close]').focus({preventScroll:true});
    } catch {
      dialog.close();
      location.assign(link.href);
    }
  });
}
